import { useEffect, useState } from 'react';
import { string as zString } from 'zod';
import { AuthState, useIdentify } from '@hungryroot/rest-hooks';

const FACEBOOK_PIXEL_ID = zString().parse(process.env.PUBLIC_FACEBOOK_PIXEL_ID);

export function FacebookPixel() {
  const { authState, customerData } = useIdentify();
  const [isInitialized, setIsInitialized] = useState(false);

  // as long as those two endpoints are done loading (whether we have a customer or order or not),
  // we can call fbq init and track the page view, but we should only call init once.
  useEffect(() => {
    if (authState === AuthState.isLoading || isInitialized) {
      return;
    }

    if (window.fbq) {
      window.fbq('init', FACEBOOK_PIXEL_ID, {
        external_id: customerData?.id?.toString() || null,
        em: customerData?.email || null,
        ph: customerData?.phone_number || null,
      });

      setIsInitialized(true);
    }
  }, [authState, isInitialized, customerData]);

  useEffect(() => {
    if (isInitialized) {
      // this should only be called when the facebook pixel is initialized
      window.fbq('track', 'PageView');
    }
  }, [isInitialized]);

  return null;
}
